import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';

function GlobalAgendaSnackbar() {
  const { message, severity, openedAt } = useSelector(
    (state) => state.meeting.agendaSnackbar
  );
  const lastShownRef = useRef(0);

  useEffect(() => {
    if (!openedAt || !message || lastShownRef.current === openedAt) {
      return;
    }
    lastShownRef.current = openedAt;

    const timeOut = 5000;
    if (severity === 'warning') {
      NotificationManager.warning(message, '', timeOut);
    } else if (severity === 'error') {
      NotificationManager.error(message, '', timeOut);
    } else if (severity === 'success') {
      NotificationManager.success(message, '', timeOut);
    } else {
      NotificationManager.info(message, '', timeOut);
    }
  }, [openedAt, message, severity]);

  return null;
}

export default GlobalAgendaSnackbar;
